export const ALLIES_CONTENT = {
  navLabel: { es: "Aliados", en: "Allies", pt: "Aliadas" },
  eyebrow: { es: "Alianzas estratégicas", en: "Strategic alliances", pt: "Alianças estratégicas" },
  title: { es: "Empresas aliadas", en: "Allied companies", pt: "Empresas aliadas" },
  sub: {
    es: "Operamos de la mano con socios especializados para cubrir cada eslabón de tu operación.",
    en: "We operate hand in hand with specialized partners to cover every link of your operation.",
    pt: "Operamos lado a lado com parceiros especializados para cobrir cada elo da sua operação.",
  },
};

export const ALLIES = [
  {
    id: "disimil",
    name: "Disimil",
    role: { es: "Transporte Ejecutivo", en: "Executive Transport", pt: "Transporte Executivo" },
  },
  {
    id: "aot-express",
    name: "AOT Express",
    role: { es: "Agente Aduanero", en: "Customs Broker", pt: "Agente Aduaneiro" },
  },
  {
    id: "for-alla-cargo",
    name: "For Allá Cargo",
    role: { es: "Transporte, Carga y Aduana", en: "Freight, Cargo & Customs", pt: "Transporte, Carga e Aduana" },
  },
];
